import React, { Component } from "react";
import { Row, Col, Alert } from "react-bootstrap";
import "src/../node_modules/react-bootstrap-table/dist/react-bootstrap-table-all.min.css";
import { msgs } from "src/js/ErrorMessage.js";
import "src/css/Util.css";
import 'src/i18n';
import { withTranslation } from 'react-i18next';


class CarScoreInfo extends Component {
  render() {
    const {t} = this.props;

    const Error = () => (
      <div>
        <Alert bsStyle="danger">
          <p>{t("Message." + msgs["msg_common_01"])}</p>
        </Alert>
      </div>
    );

    let CarOtherInfo;
    if (this.props.carOtherInfo && this.props.carOtherInfo.length > 0) {
        return(
            <div>
                <div className="score-rate" id="harsh-braking">
                    <div>{t('Common.HarshBraking')}</div>
                    <div className="star_rating" data-rate={this.props.carOtherInfo[0].value} ></div>
                </div>
                <div className="score-rate" id="harsh-acceleration">
                    <div>{t('Common.HardAcceleration')}</div>
                    <div className="star_rating" data-rate={this.props.carOtherInfo[1].value} ></div>
                </div>
                <div className="score-rate" id="cornering">
                    <div>{t('Common.HarshCornering')}</div>
                    <div className="star_rating" data-rate={this.props.carOtherInfo[2].value} ></div>
                </div>
            </div>
        );
    }

    if (this.props.isData) {
      return (
        <Col>
            {CarOtherInfo}
        </Col>
      );
    } else {
      return (
        <Row>
          <Col md={12}>
            <Error />
          </Col>
        </Row>
      );
    }
  }
}

export default withTranslation()(CarScoreInfo);



// WEBPACK FOOTER //
// ./src/component/Util/CarScoreInfo.js